'use client'

import { useTranslations } from 'next-intl'
import { HeartIcon } from 'primitives/icons'
import { RocketIcon } from 'primitives/icons/maps-and-travel'
import { LFS_URL } from '@repo/web-utils/env'

import { useContentLicenseCountQuery } from '@web/gen/content'
import { AllAccessYearlyIcon } from './icons'

export function HeaderAllAccess() {
  const t = useTranslations()
  const { data } = useContentLicenseCountQuery()

  const amountOfDownloads = data?.contentLicenseCount ?? 0
  const availableDownloads = 9_447_567 - amountOfDownloads

  const amountOfDownloadsFormatted = new Intl.NumberFormat().format(amountOfDownloads)
  const availableDownloadsFormatted = new Intl.NumberFormat().format(availableDownloads)

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${LFS_URL}/web/pages/subscription/header.jpg)`,
        }}
        className="md:py-15 text-primary-700 mb-5 bg-cover px-5 py-10 text-center"
      >
        <div className="mb-[10px] flex items-center justify-center gap-[10px] text-[18px] font-bold leading-[1.4]">
          <AllAccessYearlyIcon className="size-8" />
          {t('pages.subscription.hero_all_access.title')}
        </div>
        <h2 className="text-24 mb-5 font-bold leading-[1.3] md:mb-10 md:text-[36px] md:leading-10">
          {t('pages.subscription.hero_all_access.copy')}
        </h2>

        <div className="text-12 mx-auto grid w-full max-w-[1200px] grid-cols-1 gap-[10px] leading-[1.8] md:grid-cols-12 md:gap-5">
          <div className="bg-cf-white col-span-1 flex-1 rounded px-5 py-[30px] shadow-md md:col-span-5 md:col-start-2">
            <HeartIcon fill="currentColor" className="mx-auto mb-2 size-8 text-red-100" />
            <h4 className="text-16 mb-[5px] font-bold uppercase">
              {t('pages.subscription.hero_all_access.cards.1.title')}
            </h4>
            <p className="text-16">
              {t.rich('pages.subscription.hero_all_access.cards.1.copy', {
                count: amountOfDownloadsFormatted,
                strong: chunks => <strong>{chunks}</strong>,
              })}
            </p>
          </div>
          <div className="bg-cf-white col-span-1 flex-1 rounded px-5 py-[30px] shadow-md md:col-span-5">
            <RocketIcon className="mx-auto mb-2 size-8" />
            <h4 className="text-16 mb-[5px] font-bold uppercase">
              {t('pages.subscription.hero_all_access.cards.2.title')}
            </h4>
            <p className="text-16">
              {t.rich('pages.subscription.hero_all_access.cards.2.copy', {
                count: availableDownloadsFormatted,
                strong: chunks => <strong>{chunks}</strong>,
              })}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}
